// extracted by mini-css-extract-plugin
export default {"wrapper":"WarningInfoIcon_wrapper__kjdOR","infoIconTooltip":"WarningInfoIcon_infoIconTooltip__fHxsR"};